import { api } from '../../DefaultService';
import { ISophiaCreateProps, ISophiaProps, ISophiaUpdateParams } from './types';

const ENDPOINT = '/v1/integrations/sophia';

export const createSophiaIntegrationAsync = async (
  data: ISophiaCreateProps,
) => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllSophiaIntegrationsAsync = async (): Promise<
  ISophiaProps[]
> => {
  return await api
    .get<ISophiaProps[]>(`${ENDPOINT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getSophiaIntegrationByIdAsync = async (
  id: number,
): Promise<ISophiaProps> => {
  return await api
    .get<ISophiaProps>(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateSophiaIntegrationAsync = async ({
  id,
  data,
}: ISophiaUpdateParams) => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteSophiaIntegrationAsync = async (id: number) => {
  return await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
